export interface ScreenAuthorization {
    screenName: string;
    authorized: boolean;
}

export interface ActionAuthorization {
    actionName: string;
    authorized: boolean;
}

export interface UserAuthorization {

    screenAuthorizations: ScreenAuthorization[];
    actionAuthorizations: ActionAuthorization[];
    planningGroupAuthorizations: string[];

}

export enum UserActions {

    canAddPBToExistingTO = "canAddPBToExistingTO"

}